import MModal from "./MModal";

export default class MModalTrigger
{
	constructor(el)
	{
		this.el = el;
	}

	static initialize()
	{
		document.querySelectorAll(`[data-modal-selector]`).forEach(el => {
			const modalTrigger = new this(el);
		});

		this.addEventListeners();
	}

	static addEventListeners()
	{
		document.addEventListener('click', event => {
			if (event.target.matches('[data-modal-selector], [data-modal-selector] *')) {
				event.preventDefault();

				(new this(event.target.closest('[data-modal-selector]'))).getModal().open();
			}
		});
	}

	getModal()
	{
		return new MModal(document.querySelector(this.el.dataset.modalSelector));
	}
}
